module.exports = __webpack_public_path__ + "img/hokesmithannex-h-474x356.7860d170.jpg";